import { CIVILIZATIONS } from "../../explorer/src/config";
import { Score } from "./ScoreTable";

// Spliting up build steps into a grid, where each row equals the below interval.
export const BUILD_ORDER_GROUPING_INTERVAL = 60; // seconds
// If an item has been build in the X last steps and is X seconds ago, it will be unioned with that origiinal step
export const COMBINE_STEPS = true;
export const COMBINE_MAX_STEPS_AGO = 4;
export const COMBINE_SIMILAIR_BUILD_STEPS_MARGIN = 30; // seconds

export const SCORE_TABLE_GROUPS: Record<string, Score[]> = {
  Score: [
    {
      label: "Total",
      key: "total",
    },
    {
      label: "Milit.",
      key: "military",
    },
    {
      label: "Econ.",
      key: "economy",
    },
    {
      label: "Tech.",
      key: "technology",
    },
    {
      label: "Soci.",
      key: "society",
    },
  ],
  "Resources Spent": [
    {
      label: "Total",
      key: "totalResourcesSpent",
    },
    {
      label: "Food",
      key: "totalFoodSpent",
      color: "#FF0000",
    },
    {
      label: "Wood",
      key: "totalWoodSpent",
      color: "#E78600",
    },
    {
      label: "Gold",
      key: "totalGoldSpent",
      color: "#FFC500",
    },
    {
      label: "Stone",
      key: "totalStoneSpent",
      color: "#C3C3C3",
    },
    {
      label: "Olive Oil",
      key: "totalOliveOilSpent",
      color: "#C3C3C3",
    },
  ],
  "Max. Workers": [
    {
      label: "Villagers",
      key: "workersMax",
    },
    {
      label: "Trade",
      key: "tradersMax",
    },
    {
      label: "Fish.",
      key: "fishingMax",
    },
    // {
    //   label: "Idle",
    //   key: "workersIdleTime",
    // },
  ],
  Military: [
    {
      label: "Prod.",
      key: "militaryBuilt",
      color: "#824F34",
    },
    {
      label: "Kills",
      key: "kills",
      color: "#824F34",
    },
    {
      label: "Deaths",
      key: "deaths",
      color: "#824F34",
    },
    {
      label: "K/D",
      key: "killsPerDeath",
      color: "#824F34",
    },
  ],
  Buildings: [
    {
      label: "Razed",
      key: "buildingsRazed",
      color: "#345469",
    },
    {
      label: "Lost",
      key: "buildingsLost",
      color: "#345469",
    },
  ],
  Tech: [
    {
      label: "Research",
      key: "researchProduced",
      color: "#32806B",
    },
  ],
  Misc: [
    {
      label: "APM",
      key: "apm",
    },
  ],
  "Sacred Sites": [
    {
      label: "Capt.",
      key: "sacredSitesCaptured",
      color: "#FFDE93",
    },
    {
      label: "Lost",
      key: "sacredSitesLost",
      color: "#FFDE93",
    },
    {
      label: "Neutr.",
      key: "sacredSitesNeutralized",
      color: "#FFDE93",
    },
  ],
};

export const GAME_CIV_MAP = {
  abbasid_dynasty: CIVILIZATIONS.ab,
  chinese: CIVILIZATIONS.ch,
  delhi_sultanate: CIVILIZATIONS.de,
  english: CIVILIZATIONS.en,
  french: CIVILIZATIONS.fr,
  holy_roman_empire: CIVILIZATIONS.hr,
  malians: CIVILIZATIONS.ma,
  mongols: CIVILIZATIONS.mo,
  ottomans: CIVILIZATIONS.ot,
  rus: CIVILIZATIONS.ru,

  ayyubids: CIVILIZATIONS.ay,
  byzantines: CIVILIZATIONS.by,
  japanese: CIVILIZATIONS.ja,
  jeanne_darc: CIVILIZATIONS.je,
  order_of_the_dragon: CIVILIZATIONS.od,
  zhu_xis_legacy: CIVILIZATIONS.zx,

  house_of_lancaster: CIVILIZATIONS.hl,
  knights_templar: CIVILIZATIONS.kt,

  golden_horde: CIVILIZATIONS.gol,
  macedonian_dynasty: CIVILIZATIONS.mac,
  sengoku_daimyo: CIVILIZATIONS.sen,
  tughlaq_dynasty: CIVILIZATIONS.tug,
};

const RED = "#F60000",
  BLUE = "#0162FF",
  GREEN = "#4DE94C",
  YELLOW = "#FFEE00",
  ORANGE = "#FF8C00",
  PURPLE = "#8E00FF",
  PINK = "#FF3395",
  CYAN = "#41D8FF";

export const PLAYER_COLORS = {
  TWO_TEAMS: [
    [BLUE, CYAN, GREEN, PURPLE],
    [RED, ORANGE, YELLOW, PINK],
  ],
  THREE_OR_FOUR_TEAMS: [
    [BLUE, CYAN],
    [RED, ORANGE],
    [YELLOW, GREEN],
    [PINK, PURPLE],
  ],
  FFA_OR_UNKNOWN: [RED, BLUE, YELLOW, GREEN, ORANGE, CYAN, PINK, PURPLE],
};
